/**
 * Base path for the Membrane API.
 *
 * The path is relative, so every request stays on the page origin and no component needs to learn
 * a hostname. Fastly routes `/api` to the API in production, the Vite dev proxy routes it to
 * `VITE_API_URL` in development, and `vercel.json` covers a deployment that Fastly does not front.
 * This follows `/ingest`, which the analytics code already reaches the same way.
 */
export const API_URL = "/api";

/**
 * Base URL of the blob store. Gaze reads a blob at `${BLOB_URL}/<reference>`.
 *
 * Production reads each blob from the Fastly service for blobs, which stores every answer. That host is
 * not the page origin, so the content of a blob never runs on the page origin. Development reads each
 * blob from the api through the dev proxy. The URL is absolute, because the egui loader accepts only
 * an http or an https URL.
 */
export const BLOB_URL = import.meta.env.PROD
  ? "https://blobs.membrane-cdn.net"
  : new URL(`${API_URL}/blobs`, location.origin).toString();

/**
 * URL of the events WebSocket.
 *
 * Fastly does not pass a WebSocket upgrade on `/api`, so a production page must open the socket on
 * the API host directly. Development proxies the socket through the dev server, which keeps it on
 * the page origin and points it at whichever API `VITE_API_URL` selects.
 */
export const WS_URL = import.meta.env.PROD
  ? "wss://api.membrane.io/events/ws"
  : `${location.protocol === "https:" ? "wss" : "ws"}://${location.host}${API_URL}/events/ws`;
